import { gql } from '@apollo/client';
const ADD_COMPONENT = gql `
  mutation AddComponent($productCategoryId: ID!, $modelSpecificationId: ID!, $language: String!) {
    addComponent(
      modelSpecificationId: $modelSpecificationId
      productCategoryId: $productCategoryId
      language: $language
    ) {
      component {
        id
        productCategory {
          id
        }
      }
    }
  }
`;
export default ADD_COMPONENT;
